<template>
  <section class="container">
    <article class="pt-3" :class="[siMuestraRutaHija ? 'd-none':'' ]">
      <header class="titulo h4-responsive text-center text-md-left m-2 ml-md-5 pl-md-4 pl-lg-0 m-lg-3">
        Filtros de búsqueda
      </header>
      <FiltrosTipo1
        :transportistas="transportistasFiltro"
        :zonas="zonasFiltro"
        :fecha="false"
        :estatus-factura="false"
        nombre
        mes
        :mes-por-defecto="fechaDespacho"
        fecha-desde
        fecha-hasta
        :limpiar-fechas="limpiarFechasFlag"
        @eliminarFiltros="restablecerFiltros"
        @mesAFiltrar="onMesChange"
        @fechaDesdeAFiltrar="onFechaDesdeChange"
        @fechaHastaAFiltrar="onFechaHastaChange"
        @transportistaAFiltrar="transportistaAFiltrar=$event; cargaInicial()"
        @zonasAFiltrar="zonasAFiltrar=$event; cargaInicial()"
        @nombreAFiltrar="nombreAFiltrar=$event; cargaInicial()"
      />
      <article class="mx-2 mx-md-3">
        <div
          v-if="cargando"
          class="mensaje-no-items py-3"
        >
          <LoaderKel />
          <p class="texto mt-2">
            Cargando
          </p>
        </div>
        <div
          v-else-if="!Object.keys(despachos).length"
          class="mensaje-no-items pb-3"
        >
          <font-awesome-icon
            icon="calendar-times"
            size="5x"
            class="icono"
          />
          <p class="texto">No hay despachos en esta fecha</p>
        </div>
        <ul v-else class="table despachos">
          <li class="encabezado sticky">
            <div class="thead claro">
              <div class="col-12 col-md-2">
                <span class="text-muted">
                  ID -
                </span>
                Transportista
              </div>
              <div class="col-12 col-md-2">
                Fecha del despacho
                <span class="small-block">
                  Fecha del retorno
                </span>
              </div>
              <div class="col-12 col-md-3">
                Zonas
              </div>
              <div class="col-12 col-md-2 text-right">
                Estatus
                <span class="small-block">
                  Peso
                </span>
              </div>
            </div>
          </li>
          <li
            class="contenido cursor-pointer"
            v-for="d in despachos"
            :key="d.id_des"
            @click="$router.push(`/despacho/${d.id_des}`)"
          >
          <!-- @click="imprimirNotaDeEntrega(d)" -->
            <div
              class="col-12 col-md-2"
              data-columna="ID - Transportista"
            >
              <div>
                <span
                  title="Número de despacho"
                  class="text-muted"
                >
                  {{d.id_des}} -
                </span>
                {{d.nom_per}} {{d.ape_per}}
              </div>
            </div>
            <div
              class="col-12 col-md-2"
              data-columna="Fecha despacho Fecha retorno"
            >
              <div>
                {{formatearFechaYHora(d.fec_cre_des)}}
                <span
                  class="small-block"
                  v-if="d.fec_ret_des"
                >
                  {{formatearFecha(d.fec_ret_des).YYYYMMDD}}
                </span>
              </div>
            </div>
            <div
              class="col-12 col-md-3 col-lg-3"
              data-columna="Zonas"
            >
              <div>
                <span class="small-block">
                  <span class="auto-coma text-capitalize">
                    {{ d.zonas.toLowerCase() }}
                  </span>
                </span>
              </div>
            </div>
            <div
              class="col-12 col-md-2 text-md-right"
              data-columna="Peso"
            >
              <div>
                <span :class="['bold text-capitalize d-none d-md-block', asignarColorEstado(d.est_des)]">
                  {{ d.est_des }}
                </span>
                <span class="small-block">
                  {{convertirValorAFixed(d.pes_des)}} KG
                </span>
              </div>
            </div>
            <div
              class="col-12 d-md-none"
              data-columna="Estatus"
            >
              <div>
                <span :class="['bold text-capitalize', asignarColorEstado(d.est_des)]">
                  {{ d.est_des }}
                </span>
              </div>
            </div>
          </li>
        </ul>
      </article>
    </article>
    <AlertaMensaje
      :alertaMensaje="alertaMensaje"
      @cerrar="alertaMensaje.contenido = ''"
    />
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <router-view/>
    </transition>
  </section>
</template>

<script>
import {apiPost} from '@/funciones/api.js';
import FiltrosTipo1 from '@/components/FiltrosTipo1.vue';
import AlertaMensaje from '@/components/AlertaMensaje.vue';
import {convertirNumeroAFixed, formatearFecha, formatearFechaYHora, asignarColorEstado, comprobarRutaHija} from '@/funciones/funciones.js';
import LoaderKel from '@/components/LoaderKel.vue';

export default {
  name: 'Despachos',
  components: {
    FiltrosTipo1,
    AlertaMensaje,
    LoaderKel,
  },
  data() {
    return {
      asignarColorEstado,
      formatearFecha,
      formatearFechaYHora,
      cargando: false,
      alertaMensaje: {
        contenido: '',
      },
      despachos: {},
      fechaDespacho: new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2),
      fechaDel: '',
      fechaHasta: '',
      timeout: null,
      transportistasFiltro: [],
      zonasFiltro: [],
      transportistaAFiltrar: [],
      zonasAFiltrar: {estados: [], municipios: [], parroquias: []},
      nombreAFiltrar: '',
      limpiarFechasFlag: 0,
    };
  },
  mounted() {
    this.cargaInicial();
    apiPost({s: 'clientes_generalMv'}, '')
        .then((res) => {
          this.transportistasFiltro = res.data.tra || [];
          this.zonasFiltro = res.data.zon || [];
        });
  },
  watch: {
  },
  methods: {
    onMesChange(val) {
      this.fechaDespacho = val;
      this.fechaDel = '';
      this.fechaHasta = '';
      this.limpiarFechasFlag++;
      this.cargaInicial();
    },
    onFechaDesdeChange(val) {
      this.fechaDel = val;
      if (this.fechaHasta) this.cargaInicial();
    },
    onFechaHastaChange(val) {
      this.fechaHasta = val;
      if (val) this.cargaInicial();
    },
    convertirValorAFixed(numero) {
      return convertirNumeroAFixed(numero);
    },
    cargaInicial() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.cargando = true;
        this.resultados = {};
        let data = this.fechaDespacho ? 'y=' + this.fechaDespacho.split('-')[0] + '&m=' + this.fechaDespacho.split('-')[1] + '&' : '';
        data += this.fechaDel && this.fechaHasta ? 'del=' + this.fechaDel + '&al=' + this.fechaHasta + '&' : '';
        data += this.transportistaAFiltrar.length ? 'transportistas=' + this.transportistaAFiltrar.join(',') + '&' : '';
        data += this.zonasAFiltrar.estados.length ? 'estados=' + this.zonasAFiltrar.estados.map((e) => e.est_zon).join(',') + '&' : '';
        data += this.zonasAFiltrar.municipios.length ? 'municipios=' + this.zonasAFiltrar.municipios.map((m) => m.ciu_zon).join(',') + '&' : '';
        data += this.zonasAFiltrar.parroquias.length ? 'parroquias=' + this.zonasAFiltrar.parroquias.map((p) => p.sec_zon).join(',') + '&' : '';
        data += this.nombreAFiltrar ? 'cliente=' + this.nombreAFiltrar + '&' : '';
        apiPost({s: 'despachosMv'}, data)
            .then((res) => {
              this.despachos = res.data.des;
              this.cargando = false;
            });
      }, 500); // delay
    },
    imprimirNotaDeEntrega(des) {
      if (
        !des.v_id_per ||
        !des.fec_cre_des ||
        !des.fec_ret_des ||
        !des.m_id_per ||
        !des.a_id_per
      ) {
        this.alertaMensaje = {
          contenido: 'Faltan datos para la impresión, por favor, espera a que se proporcione información',
          tipo: 'error',
        };
        return;
      }
      const routeData = this.$router.resolve({name: 'NotaDeEntrega', params: {id: des.id_des}});
      window.open(routeData.href, '_blank');
    },
    restablecerFiltros() {
      this.fechaDespacho = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2);
      this.fechaDel = '';
      this.fechaHasta = '';
      this.transportistaAFiltrar = [];
      this.zonasAFiltrar = {estados: [], municipios: [], parroquias: []};
      this.nombreAFiltrar = '';
      this.limpiarFechasFlag++;
      this.cargaInicial();
    },
  },
  computed: {
    siMuestraRutaHija() {
      return comprobarRutaHija(this.$route.path.slice(1).split('/'));
    },
  },
};
</script>

<style lang="scss" scoped>
.table.despachos {
  margin: 0 auto 3rem;
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ("768px");
}
</style>
